/**
 * Which language the HUD is drawn in.
 *
 * The knob the conventional skin exists for. It writes to
 * [hudSkinChoice](../../hud/hudSkinChoice.ts), which the frame reads per tick, so the HUD behind a
 * settings screen raised over a running game swaps on the next update and the player judges the
 * change on the game they are actually in rather than on a menu.
 *
 * A choice rather than a toggle, because "conventional HUD: off" names one skin as the absence of
 * the other. Both are HUDs somebody chose, the diegetic one is not the neutral state, and a third
 * skin is then an option rather than a replaced control.
 *
 * The ids are that module's and the words are `text/settingsText.ts`'s. This file is the line that
 * joins them, which is all a knob ever is.
 */

import { choiceApply } from '@/ui/settings/controls/choiceButtons';
import { DEFAULT_HUD_SKIN, setHudSkin } from '@/ui/hud/hudSkinChoice';
import {
  SETTING_HUD_SKIN_DIEGETIC,
  SETTING_HUD_SKIN_HINT,
  SETTING_HUD_SKIN_LABEL,
  SETTING_HUD_SKIN_PLAIN,
} from '@/text/settingsText';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const HUD_SKIN: SettingDefinition = {
  id: 'hudSkin',
  section: 'gameplay',
  label: SETTING_HUD_SKIN_LABEL,
  hint: SETTING_HUD_SKIN_HINT,
  control: {
    kind: 'choice',
    options: [
      { value: 'diegetic', label: SETTING_HUD_SKIN_DIEGETIC },
      { value: 'plain', label: SETTING_HUD_SKIN_PLAIN },
    ],
  },
  defaultValue: DEFAULT_HUD_SKIN,
  apply: choiceApply(setHudSkin),
};
